export const OutletDetailsURLFlag = 'details'
export const OutletGiftCardPurchaseURLFlag = 'purchasegiftcards'
